import { render, staticRenderFns } from "./ProspectCreate.vue?vue&type=template&id=2f530171&"
import script from "./ProspectCreate.vue?vue&type=script&lang=js&"
export * from "./ProspectCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports